import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const designations = [
  "Frontend Developer",
  "Backend Developer",
  "Project Designer",
  "Application Developer",
  "Competitive Coder",
];

const DesignationChanger = () => {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const typingSpeed = 100;
  const deletingSpeed = 50;
  const pauseTime = 1000; 

  useEffect(() => {
    const currentText = designations[index];

    if (!isDeleting) {
      // Typing effect
      if (text.length < currentText.length) {
        setTimeout(() => setText(currentText.slice(0, text.length + 1)), typingSpeed);
      } else {
        setTimeout(() => setIsDeleting(true), pauseTime); // Pause before deleting
      }
    } else {
      // Deleting effect
      if (text.length > 0) {
        setTimeout(() => setText(currentText.slice(0, text.length - 1)), deletingSpeed);
      } else {
        setIsDeleting(false);
        setIndex((prevIndex) => (prevIndex + 1) % designations.length);
      }
    }
  }, [text, isDeleting, index]);

  return (
    <motion.h2
      className="title"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{ whiteSpace: "nowrap" }} // Ensures text stays on one line
    >
      Professional <br></br>
      <motion.span
  initial={{ opacity: 0, scale: 1 }} // Keep scale 1 to avoid shifting
  animate={{ opacity: 1 }}
  transition={{ duration: 0.5, ease: "easeInOut" }}
  style={{
    display: "inline-block",
    borderRight: "2px solid white", 
    paddingRight: 5,
    fontSize: "0.8em", 
    whiteSpace: "nowrap", 
    overflow: "hidden",
  }}
>
  {text}
</motion.span>

    </motion.h2>
  );
};

export default DesignationChanger;
